<template>
  <div class="mdc-form-field mdc-radio-container">
    <label v-bind:id="`${id}-left-label`" v-bind:for="id" class="typography--body-3 typography--color-secondary clickable" v-if="leftLabel">
      <slot name="left-label"></slot>
    </label>
    <div class="mdc-radio">
      <input class="mdc-radio__native-control"
             v-bind:id="id"
             v-bind:checked="state"
             v-on:change="onChange"
             type="radio">
      <div class="mdc-radio__background">
        <div class="mdc-radio__outer-circle"></div>
        <div class="mdc-radio__inner-circle"></div>
      </div>
    </div>
    <label
      v-if="!leftLabel"
      v-bind:id="`${id}-label`"
      class="typography--body-3 typography--color-secondary clickable"
      v-bind:for="id"
    >
      <slot name="label"></slot>
    </label>
  </div>
</template>

<script>
  export default {
    name: 'radio',

    props: [
      'id',
      'model-value',
      'check-value',
      'left-label',
    ],

    data() {
      return {
        isChecked: false,
      };
    },

    computed: {
      state() {
        return this.modelValue === this.checkValue;
      },
    },

    methods: {
      check() {
        return this.$emit('change', this.checkValue);
      },

      uncheck() {
        if (this.checkValue === true) {
          return this.$emit('change', false);
        }

        return this.$emit('change', null);
      },

      onChange() {
        if (this.state) {
          this.uncheck();
        } else {
          this.check();
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Radio.vue